import type { HTMLAttributes, ReactNode } from "react";
import "./StatusRow.css";

export type StatusRowTone = "danger" | "warning";

/**
 * Class names for a status row, for rows that keep their own element
 * (e.g. the document rows in DocumentSection). No tone = no line.
 */
export const getStatusRowClass = (tone?: StatusRowTone | null) =>
  tone ? `ds-status-row ds-status-row--${tone}` : "ds-status-row";

export interface StatusRowProps extends HTMLAttributes<HTMLDivElement> {
  /** danger = red line, warning = amber line, empty = no line */
  tone?: StatusRowTone | null;
  children?: ReactNode;
}

/**
 * A row that shows a problem with a thin coloured line on its left edge.
 * Its border and background stay as they are; only the line changes.
 * Example: <StatusRow tone="danger" className="my-row">…</StatusRow>
 */
const StatusRow = ({ tone, className, children, ...rest }: StatusRowProps) => (
  <div
    className={[getStatusRowClass(tone), className].filter(Boolean).join(" ")}
    {...rest}
  >
    {children}
  </div>
);

export default StatusRow;
